import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import { normalizeLang } from '@/mocks/sections';
import { Link } from 'react-router-dom';

export default function SEOArticleSection() {
  const { t, i18n } = useTranslation();
  const lang = normalizeLang(i18n.language);
  const langArticles = articles[lang] || articles.pt;

  return (
    <section className="w-full py-16 md:py-20 bg-white">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {t('articles.h2')}
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            Conteúdo original e independente sobre CSSBuy Spreadsheet, guias de compra, dicas de segurança e muito mais.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {langArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group block bg-white rounded-xl border border-background-200/60 overflow-hidden hover:shadow-md transition-shadow"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-1 text-xs font-medium bg-secondary-100 text-secondary-900 rounded-md"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-3 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.readTime} {t('articles.minRead')}</span>
                  <span className="flex items-center gap-1 text-primary-500 font-medium">
                    {t('articles.readMore')}
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}